<template>
  <div
    class="flex flex-col items-center justify-center w-full px-12 sm:px-16 lg:px-20 pt-12 pb-20 bg-cw-50"
  >
    <transition-group
      id="cardlist"
      tag="div"
      name="list"
      :class="[
        fourColumns ? 'md:grid-cols-2 lg:grid-cols-4' : 'lg:grid-cols-3',
      ]"
      class="grid grid-cols-1 gap-12 max-w-6xl group"
    >
      <div
        v-for="(item, i) in listLoaded"
        :key="i + 0"
        class="flex flex-col p-8 bg-white rounded-xl shadow-xl"
        :class="isCentered ? 'gap-4' : 'gap-8'"
      >
        <!-- :class="isCentered ? 'items-center' : ''" -->
        <div
          v-if="item.image || item.icon || item.logo"
          :class="item.image ? 'w-full pb-4' : 'w-full rounded-full'"
        >
          <img
            v-if="item.image"
            class="w-full max-h-56 object-cover"
            :class="item.imageClass"
            :src="item.image"
            :alt="item.title"
          />
          <img
            v-else
            :src="item.icon || item.logo"
            :alt="item.title || item.school"
            class="mx-auto"
          />
        </div>
        <!--
          <img
          v-show="item.school"
          src="/img/cw-marketing/questionmark.png"
          class="w-16 mx-auto"
          /> 
        -->

        <div class="flex flex-col gap-4">
          <div v-if="item.chips" class="flex flex-wrap gap-2 w-full">
            <div
              v-for="(chip, index) in item.chips"
              :key="index"
              class="bg-cw-alt capitalize px-2 py-1 rounded-full text-white text-xs"
              :class="chip.class"
            >
              {{ chip.text }}
            </div>
          </div>
          <div>
            <h3
              class="font-montserrat text-cw-900 font-bold leading-tight mb-3"
              :class="isCentered ? '' : ''"
            >
              {{ item.title }}
            </h3>
            <p v-if="item.text" class="font-nunito transition-all">
              {{ item.text }}
            </p>
            <ul v-if="item.bullets" class="list-disc pl-4">
              <li
                v-for="(item, index) in item.bullets"
                :key="index"
                class="mb-2"
              >
                <span>
                  {{ item }}
                </span>
              </li>
            </ul>
            <!-- Scrollable for long paragraphs -->
            <div
              v-if="item.longtext"
              class="scrollbar-hover-only-wrapper mb-2 border-b relative"
            >
              <div
                class="scrollbar-hover-only h-52"
                :style="{ overflowX: ' hidden' }"
              >
                <p class="font-nunito transition-all">{{ item.longtext }}</p>
                <div class="scrollbar-right-cover"></div>
                <div
                  class="w-full sticky bottom-0 bg-gradient-to-t from-white h-12 border-b-2 border-white"
                ></div>
              </div>
            </div>
            <div v-if="item.name">
              <h5 class="font-nunito text-left">{{ item.school }}</h5>
              <h6 class="font-nunito text-xs text-cw-300">{{ item.name }}</h6>
            </div>
          </div>
        </div>

        <div v-if="item.string" class="">
          {{ item.string }}
        </div>

        <div v-if="item.cta" class="mb-0 mt-auto">
          <div
            :style="{ width: 'max-content' }"
            class="btn mb-0 btn-trans-black font-nunito cursor-pointer"
            @click="handleCtaClick(item.cta.route)"
          >
            {{ item.cta.text }}
          </div>
        </div>
      </div>
    </transition-group>

    <button
      v-if="length < list.length"
      class="mt-12 btn btn-black font-nunito shadow-lg"
      @click="loadMore"
    >
      Load more
    </button>
  </div>
</template>

<script>
import { EventBus } from '../../../js/plugins/event-bus'

export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },

    fourColumns: {
      type: Boolean,
      default: false,
    },

    isCentered: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      length: 3,
    }
  },

  computed: {
    listLoaded() {
      return this.list.slice(0, this.length)
    },
  },

  watch: {
    fourColumns: {
      handler: function () {
        this.setColumns()
      },

      deep: true,
    },
  },

  mounted() {
    this.setColumns()
  },

  methods: {
    setColumns() {
      if (this.fourColumns) {
        this.$set(this, 'length', 4)
      }
    },

    // Load more features
    loadMore() {
      if (this.fourColumns) {
        if (this.length > this.list.length) {
          return
        }
        this.length += 4
      }
      if (this.length > this.list.length) {
        return
      }
      this.length += 3
    },

    handleCtaClick(route) {
      if (route === 'enquire') {
        EventBus.$emit('showModal', {
          action: 'cw-registration',
          data: {
            reason: 0,
          },
        })
      } else if (route === 'org') {
        EventBus.$emit('showModal', {
          action: 'cw-organisation-registration',
        })
      }
    },
  },
}
</script>

<style scoped>
/* 
Adding transition animations for list items
*/
.list-enter-active {
  animation: fade-in 0.5s ease-in-out;
}

.list-leave-active {
  animation: fade-in 0.5s ease-in-out reverse;
}

@keyframes fade-in {
  0% {
    opacity: 0;
    transform: translateY(30px);
  }

  100% {
    transform: translateY(0px);
  }
}
</style>
